import ComponentAccordionCard from './ComponentAccordionCard';
export default ComponentAccordionCard;
